<template>
  <div class="privacy">
    <h3 style="text-align: center">隐私权政策</h3>
    <br />
    <br />
    <p style="text-align: right"><b>版本更新日期：2020年08月08日</b></p>

    <p><b>引言</b></p>

    <p>
      陌陌回收（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
    </p>
    <p>本政策将帮助您了解以下内容：</p>
    <p>1、我们如何收集和使用您的个人信息</p>
    <p>2、我们如何共享、转让、公开披露您的个人信息</p>
    <p>3、我们如何使用 Cookie 和同类技术</p>
    <p>4、我们如何保护和保存您的个人信息</p>
    <p>5、您如何管理个人信息</p>
    <p>6、未成年人信息的保护</p>
    <p>7、您的信息如何在全球范围转移</p>
    <p>8、修订和更新</p>
    <p>9、如何联系我们</p>
    <p>
      本隐私政策与您所使用的陌陌回收网站、陌陌回收app客户端、小程序提供的服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读<b>（尤其请您务必仔细阅读本隐私政策中我们认为与您的切身利益相关，并以加粗字体显示的内容）</b>并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策（含更新版本）内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。
    </p>
    <p>最近更新日期：2020年08月08日。</p>
    <p>如对本隐私政策或相关事宜有任何问题，您可随时通过以下方式联系我们：</p>
    <p>1、在线客服咨询</p>
    <p>2、电话：0755-2103-6187</p>

    <br />
    <br />
    <p><b>目录</b></p>
    <p><b>一、 我们如何收集和使用您的个人信息</b></p>
    <p><b>二、 我们如何共享、转让、公开披露您的个人信息</b></p>
    <p><b>三、 我们如何使用Cookie和同类技术的使用</b></p>
    <p><b>四、 我们如何保护和保存个人信息的管理</b></p>
    <p><b>五、 您如何管理您的个人信息</b></p>
    <p><b>六、 未成年人的个人信息保护</b></p>
    <p><b>七、 您的信息如何在全球范围转移</b></p>
    <p><b>八、 修订和更新</b></p>
    <p><b>九、 如何联系我们</b></p>

    <br />
    <h4>一、我们如何收集和使用您的个人信息</h4>
    <p>
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：<b>基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证等）；面部特征；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易和消费记录、优惠券）</b>；通讯录；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android
      ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；个人位置信息（包括行程信息、精准定位信息、住宿信息、经纬度等）；
    </p>
    <p>
      <b
        >个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括：您的财产信息（交易和消费记录、优惠券等虚拟财产信息）；面部识别特征；个人身份信息（包括身份证、军官证、护照、驾驶证、户口本）；网络身份识别信息（包括账户名、账户昵称、邮箱地址及与前述有关的密码与密码保护问题和答案）；其他信息（包括通讯录、个人电话号码、手机号码、行程信息、网页浏览记录、住宿信息、精准定位信息）。</b
      >
    </p>
    <p>
      以上个人信息和个人敏感信息包含的内容出自于GB/T35273《个人信息安全规范》，分别与附录A附录A（资料性附录）-个人信息示例-表A.1
      个人信息举例中的内容和附录B（资料性附录）-个人敏感信息判定-表B.1
      个人敏感信息举例一致。
    </p>
    <p>我们仅会出于以下目的，收集和使用您的个人信息：</p>
    <h4>（一） 您须授权我们收集和使用您个人信息的情形</h4>
    <p>
      我们的产品与/或服务包括一些核心功能，这些功能包含了实现网上购物所必须的功能、观看直播所必须的功能、改进我们的产品与/或服务所必须的功能及保障交易安全所必须的功能。<b
        >我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：</b
      >
    </p>
    <h4>1、实现消费所必须的功能</h4>
    <h4>（1）用户注册与登陆陌陌回收账户</h4>
    <p>
      您首先需要注册一个陌陌回收账户成为陌陌回收用户。<b>当您注册时，您需要至少向我们提供您准备使用的陌陌回收账户名、密码、您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效。</b>您的用户名称默认为空，当您首次注册设置后即不可修改，您可以修改补充您的昵称、性别、<b>手机号、</b>生日以及<b>您的实名验证相关信息（其中高级实名需要联系客服修改）</b>，这些信息均属于您的“账户信息”。您补充的账户信息将有助于我们为您提供个性化的商品或服务推荐和更优的购物体验，但如果您不提供这些补充信息，不会影响您网上购物的基本功能。当您使用第三方登陆您的陌陌回收账户时，我们可能还会收集您的微信头像信息、微信性别信息、<b>微信地理信息、</b>微信openid信息、支付宝头像信息、昵称信息、支付宝脱敏的用户id信息。
    </p>
    <h4>（2）商品与/或服务信息展示和搜索</h4>
    <p>
      <b
        >为了让您快速地找到您所需要的商品与/或服务，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、浏览器类型来为您提供商品或服务信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</b
      >
    </p>
    <p>
      您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品或服务。<b
        >请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。</b
      >
    </p>
    <p>（3）下单</p>
    <p>
      当您准备对您购物车内或者线下购买的商品或服务进行结算时，陌陌回收系统会生成您购买该商品或服务的订单。<b
        >您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、您应支付的货款金额及支付方式。</b
      >
    </p>
    <p>
      <b
        >您在陌陌回收购买手机号卡、合约机时，您还可能需要根据国家法律法规或服务提供方（包括基础电信运营商、移动转售运营商）的要求提供您的实名信息，这些实名信息可能包括您的身份信息（包括您的身份证、军官证、护照、驾驶证载明您身份的证件复印件或号码）、您本人的照片或视频、姓名、电话号码。这些订单中将可能包含您的地址、您指定的服务或设备安装地址（可能是您的家庭地址）信息。</b
      >
    </p>
    <p>
      上述所有信息构成您的“订单信息”，我们将使用您的订单信息来进行<b>您的身份核验、确定交易、支付结算、</b>完成配送、为您查询订单以及提供客服咨询与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
    </p>
    <h4>（4）支付功能</h4>
    <p>
      在您下单后，您可以选择陌陌回收的关联方或与陌陌回收合作的第三方支付机构所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的陌陌回收订单号与<b>交易金额信息</b>与这些支付机构共享以实现其确认您的支付指令并完成支付。“关联方”指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
    </p>
    <h4>（5）交付产品或服务功能</h4>
    <p>
      在当您下单并选择货到付款或在线完成支付后，陌陌回收的关联方或与陌陌回收合作的第三方配送公司（以下简称“配送公司”）将为您完成订单的交付。您知晓并同意陌陌回收的关联方或与陌陌回收合作的第三方配送公司会在上述环节内使用您的<b>订单信息</b>以保证您的订购的商品能够安全送达。
    </p>
    <p>
      我们的配送员在为您提供配送服务的同时，基于某些业务法律要求<b>实名认证</b>的需求，会协助您完成<b>实名认证</b>，如您购买手机号卡时。我们在此环节会使用您的<b>身份证</b>通过国家有权认证机构的专有设备对您的身份进行核验，我们并没有收集您的<b>身份证</b>信息，且我们的配送员均须遵守公司保密制度的规定。
    </p>
    <h4>（6）客服与售后功能</h4>
    <p>我们的电话客服和售后功能会使用您的账号信息和订单信息。</p>
    <p>
      为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供售前咨询或者与您订单信息相关的客服与售后服务时，我们将会查询您的访问记录或者订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更<b>配送地址、联系人或联系电话时</b>。
    </p>
    <h4>（7） 产品业务功能所收集使用您的信息逐项列举</h4>
    <table
      border="1"
      style="
        line-height: 24px;
        border-collapse: collapse;
        text-align: center;
        font-size: 16px;
      "
    >
      <tr>
        <th style="width: 20%">业务场景</th>
        <th style="width: 80%">个人信息字段</th>
      </tr>
      <tr>
        <td>下单</td>
        <td>姓名、个人手机号码、地址、定位</td>
      </tr>
      <tr>
        <td>租赁服务</td>
        <td>
          个人姓名、生日、个人手机号码、地址、身份证、指纹、面部特征、银行账号、通讯录、已安装应用列表、通话详单
        </td>
      </tr>
      <tr>
        <td>分期服务</td>
        <td>
          个人姓名、生日、个人手机号码、地址、身份证、指纹、面部特征、银行账号、通讯录、广告跟踪idfa
        </td>
      </tr>
      <tr>
        <td>订单</td>
        <td>购物记录、物流信息</td>
      </tr>
      <tr>
        <td>新增地址</td>
        <td>个人手机号码、地址</td>
      </tr>
      <tr>
        <td>搜索</td>
        <td>购物记录、浏览记录、关注记录</td>
      </tr>
      <tr>
        <td>广告</td>
        <td>
          浏览记录、购物记录、设备信息、关注记录、WIFI信息、IMEI、广告跟踪idfa、安卓设备唯一标识
        </td>
      </tr>
      <tr>
        <td>排行榜</td>
        <td>购物记录、浏览记录、关注记录</td>
      </tr>
      <tr>
        <td>数据采集</td>
        <td>
          采集设备信息、浏览记录、购物记录、关注记录
        </td>
      </tr>
      <tr>
        <td>常购清单</td>
        <td>购物记录</td>
      </tr>
      <tr>
        <td>足迹</td>
        <td>浏览记录</td>
      </tr>
      <tr>
        <td>关注中心</td>
        <td>关注记录</td>
      </tr>
      <tr>
        <td>会员中心</td>
        <td>
          个人姓名、性别、出生日期、个人手机号码、地址
        </td>
      </tr>
      <tr>
        <td>发票</td>
        <td>姓名、工作单位名称</td>
      </tr>
      <tr>
        <td>人气推荐</td>
        <td>浏览记录、购物记录、关注记录</td>
      </tr>
      <tr>
        <td>推送</td>
        <td>浏览记录、购物记录、关注记录</td>
      </tr>
      <tr>
        <td>回收收款方式</td>
        <td>支付宝账号、微信账号、银行卡信息</td>
      </tr>
      <tr>
        <td>以旧换新</td>
        <td>设备信息</td>
      </tr>
      <tr>
        <td>回收机型估价</td>
        <td>用户估计记录、历史机型记录</td>
      </tr>
      <tr>
        <td>报表</td>
        <td>浏览记录、购物记录、支付记录、位置信息</td>
      </tr>
    </table>

    <h4>2、实现直播互动所必须的功能</h4>
    <p>
      当您选择我们的相关应用进行直播录制时，我们需要开启您所使用设备的摄像头及麦克风使用权限，以完成完整的直播录制及录制过程中附带的功能，并在首次开启权限时以弹窗告知形式征询您的同意；如果您拒绝开启摄像头和麦克风权限，将无法完成直播录制。在直播录制过程中，我们将记录并保存<b>您所展现的一切动态、静态画面</b>并对其他用户进行展示。同时，根据国家相应法律法规，我们将实时<b>监测您的直播画面</b>，确保您的直播内容符合法律法规及公序良俗。
    </p>
    <h4>3、改进我们的产品与/或服务所必须的功能</h4>
    <p>
      <b
        >我们可能会收集您的订单信息、浏览信息、您的兴趣爱好（您可以在账户设置中）进行数据分析以形成用户画像，用来将您感兴趣的商品或服务信息展示给您；或在您搜索时向您展示您可能希望找到的商品或服务。</b
      >我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。
    </p>
    <h4>4、保障交易安全所必须的功能</h4>
    <p>
      为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的浏览信息、订单信息、您常用的软件信息、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android
      ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）和IP地址；我们也会收集您的设备信息对于陌陌回收系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。
    </p>
    <h4>（二）您可选择是否授权我们收集和使用您的个人信息的情形</h4>
    <p>
      1、为使您消费、获取资讯更便捷或更有乐趣，从而提升您在陌陌回收的网上消费及视听娱乐体验，我们的以下附加功能中可能会收集和使用您的个人信息。<b>如果您不提供这些个人信息，您依然可以进行网上消费、获取资讯及视听娱乐，但您可能无法使用这些可以为您所带来消费乐趣的附加功能或在购买某些商品/服务时需要重复填写一些信息。</b>这些附加功能包括：
    </p>
    <p>
      （1）基于精确和粗略位置信息的个性化推荐功能：<b>我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点。</b>包括自动为您快速新建收货地址方便您快速购物，向您推荐离您最近的，我们认为适合您观看的视听内容、直播。
    </p>
    <p>
      （2）基于摄像头（相机）的附加功能：您可以使用这个附加功能完成视频拍摄、拍照、扫码、人脸识别登录以及人脸识别租赁业务反欺诈的功能。<b>当您使用人脸识别登录时我们会收集您的面部信息。</b>未来我们可能会将人脸识别技术应用于更多场景，但那时我们会再次与您确认您是否愿意我们使用您的面部信息来实现这些附加功能。
    </p>
    <p>
      （3）基于相册（图片库/视频库）的图片/视频访问及图片上传的附加功能：您可以在陌陌回收上传您的照片来实现拍照购物功能和晒单及评价功能，<b
        >我们会使用您所上传的照片来识别您需要购买的商品或使用包含您所上传图片的评价。</b
      >
    </p>
    <p>
      （4）基于语音技术的附加功能：您可以直接使用麦克风来进行语音购物或与我们的客服机器人进行咨询和互动。<b
        >在这些功能中我们会收集您的录音内容以识别您购物需求和客服与售后需求。</b
      >
    </p>
    <p>
      （5）基于通讯录信息的附加功能：<b>我们将收集您的通讯录信息以方便您在购物时不再手动输入您通讯录中联系人的信息（快速填写收货联系人，租赁紧急联系人）；</b>为了增加您购物及观看影视、直播时的社交乐趣，在获得您的同意下我们也可以判断您的好友是否也同为陌陌回收用户，并在陌陌回收为你们的交流建立联系
    </p>
    <p>
      （6）基于读取和接收短信/读取通话记录*/图片日志信息的附加功能：<b>当您使用陌陌回收免押租赁下单时，为了开展反欺诈建模，判断您是否符合免押租赁条件，并向您提供与您风险承受能力相匹配的租赁服务，在经过您的授权同意后，我们会收集与租赁审核相关的短信记录/通话记录*/图片日志信息，但我们不会获取您的其他短信信息、通话内容以及图片内容。</b>若您不同意我们获取您的与租赁审核相关的短信记录/通话记录*/图片日志信息，不会影响您使用陌陌回收其他功能的服务。
    </p>
    <p>
      （7）基于获取应用账户的附加功能：<b>我们将收集您的应用账户信息以方便您在租赁手机时填写登录账户信息时可以自动帮你完成登录不再手动输入您的账户信息，并能快速的切换账户。你在此过程注册的账户也能在您授权同意时帮你记录，让你实现更快捷的体验。</b>如获取google账号，微博帐号等列表，不包括微信账号和QQ账号和用户手动输入的电话号码等。若您不同意我们获取您的获取应用账号，不会影响您正常登录使用陌陌回收的服务。
    </p>
    <p>
      （8）基于资格、信用及偿付能力审核功能：<b>您在使用陌陌回收信用服务，包括陌陌回收分期、免押租赁服务时，根据您所选择的服务，您需要自主填写或提交您的姓名、身份证号码、地址、职业、教育、银行卡号、手机号、财产信息、婚姻状态、联系人信息，我们还会收集您的面部信息、位置信息、已安装应用列表。</b>这些信息将被用来对您的信贷资格、信用及偿付能力进行审核，帮助我们做好风险管理工作。如果您不提供上述信息，我们则无法对您的资格、信用及偿付能力进行评估并决定是否提供您所需的服务。
    </p>
    <p>
      （9）基于其他设备信息的附加功能：为了提供更好的产品和/或服务并改善用户体验，<b>我们会收集设备属性信息（包括您的硬件型号、操作系统版本、设备配置、唯一设备标识符、国际移动设备身份码IMEI、网络设备硬件地址MAC、广告标识符IDFA），设备连接信息（浏览器的类型、电信运营商、使用的语言）以及设备状态信息（包括设备传感器数据，设备应用安装列表）</b>。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将您的设备信息或电话号码与您的陌陌回收帐户相关联。
    </p>
    <p>
      2、上述附加功能可能需要您在您的设备中向我们开启您的<b
        >地理位置（位置信息）、相机（摄像头）、相册（图片库）、麦克风、通讯录，短信，通话记录，获取应用账号以及其他设备访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在陌陌回收的隐私模块（[我的—账户设置——隐私设置]）中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</b
      >
    </p>
    <h4>3、实现相关业务功能可能开启您的设备访问权限的逐项列举：</h4>
    <table
      border="1"
      style="
        line-height: 24px;
        border-collapse: collapse;
        text-align: center;
        font-size: 16px;
      "
    >
      <tr>
        <th style="width: 33%">业务场景</th>
        <th style="width: 34%">场景说明</th>
        <th style="width: 33%">访问及使用权限</th>
      </tr>
      <tr>
        <td rowspan="2">个人</td>
        <td>编辑物流信息时，从用户通讯录选择联系人作为收件人</td>
        <td>访问通讯录权限</td>
      </tr>
      <tr>
        <td>编辑个人头像信息时选择自拍或者从相册选择</td>
        <td>使用照相设备权限<br />访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td>地址</td>
        <td>编辑物流信息时，新增地址，点击定位</td>
        <td>访问粗略的地位信息<br />访问精确的地位信息</td>
      </tr>
      <tr>
        <td>分享</td>
        <td>
          用户在陌陌回收内分享图片到朋友圈时，需要从相册选择图片或者保存图片到本地
        </td>
        <td>访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td rowspan="2">晒单</td>
        <td>用户发表、修改、评价时，拍摄短视频</td>
        <td>使用照相设备权限<br />访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td>用户发表、修改评价</td>
        <td>记录语音信息权限<br />访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td>搜索</td>
        <td>用户使用语音搜索方式时</td>
        <td>记录语音信息权限</td>
      </tr>
      <tr>
        <td>数据统计</td>
        <td>获取设备信息唯一标识</td>
        <td>访问设备信息</td>
      </tr>
      <tr>
        <td rowspan="2">美洽客服</td>
        <td>美洽智能客服沟通时拍照上传</td>
        <td>使用照相设备权限<br />访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td>美洽智能客服沟通时录入语音并上传</td>
        <td>记录语音信息权限<br />访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td rowspan="4">即时通讯</td>
        <td>需要根据用户定位位置推送信息</td>
        <td>访问粗略的地位信息<br />访问精确的地位信息</td>
      </tr>
      <tr>
        <td>在聊天过程中，拍照片或者短视频发送</td>
        <td>使用照相设备权限<br />访问外部存储权限<br />写外部存储权限</td>
      </tr>
      <tr>
        <td>在聊天过程中，接收并保存客服图片</td>
        <td>写外部存储权限</td>
      </tr>
      <tr>
        <td>极光友盟、小米推送SDK、华为推SDK时生成设备Token</td>
        <td>访问电话状态，当前网络信息，呼叫信息</td>
      </tr>
      <tr>
        <td>手机检测</td>
        <td>检测手机硬件健康状况</td>
        <td>访问电话状态<br />使用拨号呼叫权限<br />使用蓝牙信息权限</td>
      </tr>
      <tr>
        <td>手机租赁</td>
        <td>
          手机租赁下单流程，需要上传身份证、人脸识别、上传联系信息和gps定位信息，用于反欺诈风控
        </td>
        <td>
          访问外部存储权限<br />访问精确的地位信息<br />使用照相设备权限<br />使用麦克风设备权限<br />访问通讯录权限<br />访问设备权限<br />访问读取短信权限<br />访问通话记录权限<br />获取应用账号权限
        </td>
      </tr>
      <tr>
        <td>批量回收/回收订单跟踪</td>
        <td>下单后，联系客服</td>
        <td>使用拨号呼叫权限</td>
      </tr>
    </table>

    <h4>
      （三）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
    </h4>
    <p><b>1、与个人信息控制者履行法律法规规定的义务相关的；</b></p>
    <p><b>2、与国家安全、国防安全直接相关的；</b></p>
    <p><b>3、与公共安全、公共卫生、重大公共利益直接相关的；</b></p>
    <p><b>4、与犯罪侦查、起诉、审判和判决执行等直接相关的；</b></p>
    <p>
      <b
        >5、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</b
      >
    </p>
    <p><b>6、所涉及的个人信息是个人信息主体自行向社会公众公开的；</b></p>
    <p><b>7、根据个人信息主体要求签订和履行合同所必需的；</b></p>
    <p>
      <b
        >8、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</b
      >
    </p>
    <p>
      <b
        >9、维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</b
      >
    </p>
    <h4>（四）我们从第三方获得您个人信息的情形（个人信息的间接获取）</h4>
    <p>
      我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的陌陌回收账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
    </p>
    <p>
      我们承诺，我们从第三方间接获取您的个人信息的数量为实现陌陌回收产品业务功能所必须的最少数量。
    </p>
    <p>
      我们承诺，在从第三方间接获取您的个人信息时，要求第三方说明个人信息来源，并会对其个人信息来源的合法性进行确认；我们将了解并审慎注意，第三方已获得您的个人信息处理的授权同意范围，包括使用目的，您是否授权同意转让、共享、公开披露等。我们开展业务所需进行的个人信息处理活动超出该授权同意范围的，将在获取您的个人信息后的合理期限内或处理您的个人信息前，征得您的明示同意。
    </p>
    <h4>（五）我们在您使用产品及服务过程中收集的信息</h4>
    <p>我们会收集关于您使用我们产品或服务以及使用方式的信息，这些信息包括：</p>
    <p>
      <b>设备信息：</b
      >我们会根据您在软件安装及/或使用中授予的具体权限，接收并记录您所使用的设备相关信息（设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（IP
      地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站等传感器信息）。如果您在安装及/或使用过程中拒绝授予我们相应权限的，我们并不会记录您上述对应的信息。
    </p>
    <p>
      <b>服务日志信息：</b
      >当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。
    </p>
    <p>
      <b
        >其他相关信息：为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。包括为确保您使用我们服务时能与您认识的人分享购物体验，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密收集。</b
      >
    </p>
    <p>
      请您理解，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。除非将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，那么在结合使用期间，这类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理（取得您的授权或法律法规另有规定的情况除外）。
    </p>
    <p>
      当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话并收集其他为解决问题所需的必要信息。
    </p>
    <h4>（六）您个人信息使用的规则</h4>
    <p>
      1、我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。
    </p>
    <p>
      2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。<b
        >请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</b
      >
    </p>
    <p>
      3、<b
        >请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息或对您的个人信息进行匿名化处理。</b
      >
    </p>
    <p>
      4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
    </p>
    <p>
      5、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。
    </p>
    <p>
      6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。
    </p>
    <p>
      <b>7、对用于画像的个人信息使用的应用场景及可能对您产生的影响逐项列举：</b>
    </p>
    <table
      border="1"
      style="
        line-height: 24px;
        border-collapse: collapse;
        text-align: center;
        font-size: 16px;
      "
    >
      <tr>
        <th style="width: 20%">应用场景</th>
        <th style="width: 80%">业务功能及影响</th>
      </tr>
      <tr>
        <td>搜索</td>
        <td>
          在匹配用户搜索结果时，根据购物、浏览、关注记录匹配更相关的搜索结果
        </td>
      </tr>
      <tr>
        <td>广告</td>
        <td>根据用户购物、浏览、关注记录匹配展示广告商品或营销活动</td>
      </tr>
      <tr>
        <td>排行榜</td>
        <td>根据用户浏览的品类信息，汇总推荐展示该品类下相关的商品</td>
      </tr>
      <tr>
        <td>找相似</td>
        <td>根据用户浏览记录，展示相似的商品</td>
      </tr>
      <tr>
        <td>人气推荐</td>
        <td>
          根据用户的浏览记录、购物记录、关注记录推荐展示相关商品、店铺或者内容
        </td>
      </tr>
      <tr>
        <td>推送</td>
        <td>根据用户的浏览记录、购物记录、关注记录推送相关商品或营销活动</td>
      </tr>
    </table>

    <h4>二、我们如何共享、转让、公开披露您的个人信息</h4>
    <h4>（一）委托处理</h4>
    <p>
      委托进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。<b>我们可能会使用您的个人信息以及您的非个人信息集合形成的间接用户画像与委托我们进行推广的合作伙伴（“委托方”）共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。</b>包括我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <h4>（二）共享</h4>
    <p>
      <b
        >1、我们不会与陌陌回收以外的任何公司、组织和个人共享您的个人信息，但以下情况及下述第2、3条情形除外：</b
      >
    </p>
    <p>（1）事先获得您明确的同意或授权；</p>
    <p>
      （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
    </p>
    <p>
      2、<b
        >我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</b
      >
    </p>
    <p>
      3、<b>我们可能会向合作伙伴及第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。</b>我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括以下类型：
    </p>
    <p>
      （1）商品或技术服务的供应商。<b>我们可能会将您的个人信息共享给支持我们功能的第三方。</b>这些支持包括为我们的供货或提供基础设施技术服务、物流配送服务、支付服务、数据处理。我们共享这些信息的目的是可以实现我们产品与/或服务的核心购物功能，包括我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付。
    </p>
    <p>
      （2）第三方商家。<b
        >我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。</b
      >
    </p>
    <p>
      4、我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。
    </p>
    <p>
      5、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护陌陌回收、您或其他陌陌回收客户的权利及其财产或安全，包括为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。
    </p>
    <p><b>6、我们向合作伙伴及第三方共享您的个人信息的情形逐项列举：</b></p>
    <table
      border="1"
      style="
        line-height: 24px;
        border-collapse: collapse;
        text-align: center;
        font-size: 16px;
      "
    >
      <tr>
        <th style="width: 12%">产品名称</th>
        <th style="width: 12%">场景描述</th>
        <th style="width: 12%">个人信息类型</th>
        <th style="width: 18%">个人信息字段</th>
        <th style="width: 26%">第三方机构名称</th>
        <th style="width: 10%">数据是否去标识化传输</th>
        <th style="width: 10%">是否嵌入第三方代码、插件传输个人信息</th>
      </tr>
      <tr>
        <td>高德地图</td>
        <td>地理定位</td>
        <td>个人常用设备信息、个人位置信息</td>
        <td>设备信息、位置信息</td>
        <td>
          <div>高德软件有限公司</div>
          <div>https://www.amap.com</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>极光推送</td>
        <td>消息推送、快捷登录</td>
        <td>个人常用设备信息</td>
        <td>设备信息、位置信息</td>
        <td>
          <div>深圳市和讯华谷信息技术有限公司</div>
          <div>https://www.jiguang.cn</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>友盟推荐</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>北京锐讯灵通科技有限公司</div>
          <div>https://www.umeng.com</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>QQ分享</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>深圳市腾讯计算机系统有限公司</div>
          <div>https://open.weixin.qq.com/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>微信分享</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>深圳市腾讯计算机系统有限公司</div>
          <div>https://open.weixin.qq.com/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>中国移动</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>中国移动通信集团有限公司</div>
          <div>http://www.10086.cn</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>中国电信</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>中国电信集团有限公司</div>
          <div>http://www.chinatelecom.com.cn/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>中国联通</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>中国联合网络通信集团有限公司</div>
          <div>http://www.chinaunicom.com.cn/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>美洽</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>成都美洽网络科技有限公司</div>
          <div>http://www.meiqia.com/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>微信支付</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>深圳市腾讯计算机系统有限公司</div>
          <div>https://wx.qq.com/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
      <tr>
        <td>支付宝支付</td>
        <td>地理定位</td>
        <td>个人常用设备信息</td>
        <td>设备信息</td>
        <td>
          <div>支付宝(中国)网络技术有限公司</div>
          <div>http://www.alipay.com/</div>
        </td>
        <td>是</td>
        <td>是</td>
      </tr>
    </table>

    <h4>（三）转让</h4>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1、事先获得您明确的同意或授权；</p>
    <p>
      2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
    </p>
    <p>
      3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
    </p>
    <p>
      <b
        >4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</b
      >
    </p>
    <h4>（四）公开披露</h4>
    <p>
      我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
    </p>
    <p>1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
    <p>
      2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。
    </p>
    <h4>三、我们如何使用Cookie 和同类技术</h4>
    <h4>（一）Cookie的使用</h4>
    <p>
      1、为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为
      Cookie的小数据文件。Cookie
      通常包含标识符、站点名称以及一些号码和字符。<b>借助于Cookie，网站能够存储您的偏好或购物车内的商品及服务数据。</b>我们向您发送Cookie是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品及服务数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。
    </p>
    <p>
      2、我们不会将 Cookie
      用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
      Cookies。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有
      Cookie，大部分网络浏览器都设有阻止 Cookies
      的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
    </p>
    <h4>（二）网站信标和像素标签及其他同类技术的使用</h4>
    <p>
      除 Cookie
      外，我们还会在网站上使用网站信标和像素标签及其他同类技术。我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
    </p>
    <h4>四、我们如何保护和保存个人信息的管理</h4>
    <h4>（一）我们保护您个人信息的技术与措施</h4>
    <p>
      我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
    </p>
    <p>1、数据安全技术措施</p>
    <p>
      我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，免数据的损坏或丢失。
    </p>
    <p>
      陌陌回收的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
    </p>
    <p>
      陌陌回收采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。
    </p>
    <p>
      在个人信息使用时，我们会采用包括内容替换、SHA256，MD5在内多种数据脱敏技术增强个人信息在使用中安全性。
    </p>
    <p>
      陌陌回收采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
    </p>
    <p>
      陌陌回收采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。
    </p>
    <p>2、陌陌回收为保护个人信息采取的其他安全措施</p>
    <p>
      陌陌回收通过建立数据分类分级制度、数据安全管理规范来管理规范个人信息的存储和使用。
    </p>
    <p>
      陌陌回收通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
    </p>
    <p>陌陌回收建立数据安全管理组织来推进和保障个人信息安全。</p>
    <p>
      加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    </p>
    <p>
      3、我们仅允许有必要知晓这些信息的陌陌回收及陌陌回收关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与陌陌回收的合作关系。
    </p>
    <p>
      4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
    </p>
    <p>
      <b
        >5、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。</b
      >
    </p>
    <p>
      <b
        >6、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</b
      >
    </p>
    <p>7、安全事件处置</p>
    <p>
      在通过陌陌回收网站与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。
    </p>
    <p>
      为应对个人信息泄露、损毁和丢失等可能出现的风险，陌陌回收制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。陌陌回收也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
    </p>
    <p>
      在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
    </p>
    <p>
      8、如果您对我们的个人信息保护有任何疑问，可通过本政策最下方约定的联系方式联系我们。<b
        >如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策最下方【如何联系我们】约定的联系方式联络我们，以便我们采取相应措施。</b
      >
    </p>
    <h4>（二）您个人信息的保存</h4>
    <p>
      1、原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。数据存储期间为二十年。如果我们更改数据存储时间，会另行提前通知您。在注销账户之后，我们将停止为您提供产品和服务，并根据您的要求，删除您的个人信息或匿名化处理，法律法规另有规定的除外。
    </p>
    <p>
      <b
        >2、请您注意，当您成功申请注销陌陌回收账户后，我们将在您提出申请后完成对您的账户注销审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。</b
      >
    </p>
    <p>
      <b
        >3、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</b
      >
    </p>
    <h4>五、您如何管理您的个人信息</h4>
    <p>
      陌陌回收非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
    </p>
    <p><b>1、访问和更正您的个人信息</b></p>
    <p>
      除法律法规规定外，您有权随时访问和更正您的个人信息。移动端，您可以在“个人”页面点击您的头像或者账号名称，进入“账号设置”或“账户管理”或类似模块查询和更正您的联系方式、地址、密码个人信息。举例说明：
    </p>
    <p>
      （1）<b>您的账户信息：</b>移动端具体路径为：账户名称、个人资料信息：首页--“个人”进入个人--点击头像进入个人信息，昵称，头像：首页--“根据”进入个人--设置--账户与安全--修改密码、第三方账户绑定、地址管理。
    </p>
    <p>
      <b
        >我们可能收集您的手机微信账号、QQ账号、支付宝账号、邮箱、手机号、push推送权限。您可以在我的--消息中心--消息提醒设置里关闭已开启的push推送权限或在手机自带的权限设置中关闭陌陌回收APP的push推送权限；您可以在我的--账号设置--关联账号中解绑已绑定的微信账号、QQ账号、支付宝账号；您可以在收到陌陌回收给您推送的营销类短信后回复“T”退订短信推送服务；您可以在收到陌陌回收给您推送的营销类邮件后通过下方退订链接进行退订。</b
      >
    </p>
    <p>
      （2）<b>您的收货信息：</b>移动端具体路径为：移动端首页--“个人”进入我的--我的订单/待收款/待收货/退换售后。<b
        >您可以选择删除已经完成的订单来删除您的订单信息，但这样可能导致我们无法准确判断您的购买信息而难以提供相应的售后服务。</b
      >
    </p>
    <p>
      （3）<b>您的浏览信息：</b>您可以访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。移动端路径为：搜索历史记录：首页--“个人”进入个人--足迹。
    </p>
    <p>（4）<b>您的评论信息：</b>移动端路径为：个人—订单—可晒单。</p>
    <p>（5）<b>您的发票信息：</b>联系客户端APP在线客服申请即可。</p>
    <p><b>2、删除您的个人信息</b></p>
    <p>
      您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括订单信息、浏览信息、收货地址信息；
    </p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>（1）如果我们处理个人信息的行为违反法律法规；</p>
    <p>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p>（3）如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>（4）如果我们终止服务及运营。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    </p>
    <p><b>3、改变您授权同意的范围或撤回您的授权</b></p>
    <p>
      <b
        >您可以通过删除信息、关闭设备功能、在陌陌回收网站或软件中进行“隐私设置”等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</b
      >
    </p>
    <p>
      <b
        >请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</b
      >
    </p>
    <p><b>4、注销账户</b></p>
    <p>1、您可以直接联系在线客服申请注销账户</p>
    <p>
      2、您可以在我们的产品中直接申请注销账户。在各个陌陌回收网站的展示文案和注销路径可能略有区别。举例说明：
    </p>
    <p>
      移动端路径：个人--点击“设置”--点击“申请注销”。关于您注销账户的方式以及您应满足的条件，请详见《陌陌回收账户注销须知》。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。
    </p>
    <p>
      <b>5、如果您不想接受我们给您发送的促销信息，您随时可通过以下方式取消：</b>
    </p>
    <p>
      （1）您可以随时回复“TD”或“T”（具体以短信通知为准）来取消我们给您发送的手机促销短信。
    </p>
    <p>
      （2）您可以通过移动端
      “个人中心--设置--消息推送”关闭给您的商品或服务和促销信息。
    </p>
    <p>
      （3）我们会与第三方的平台或媒体（“平台”）合作基于您的个人信息向您推荐个性化的商品或服务。这些个人信息包括诸如在本网站的购物情况、访问本网站关联公司网站的情况及您在您的账户设置中填写的兴趣爱好。平台仅向我们提供了展示商品或服务的窗口，窗口内容的链接是陌陌回收站内的个性化商品或服务的展示信息，由陌陌回收进行管理，因此我们不会向广告商提供您的任何的个人信息。而且我们在推荐窗内设置了屏蔽功能，您可选择屏蔽您不喜欢的广告。如您不愿意接受陌陌回收在单个平台上的推荐服务，请联系平台进行关闭。您知晓并理解平台是自主经营的实体，陌陌回收无法对其进行管理。
    </p>
    <p>
      （4）为了保护您的隐私，我们不会以任何方式和途径向您推送涉及宗教信仰、性、疾病等相关敏感内容的促销或商品及服务信息给您。
    </p>
    <p><b>6、约束信息系统自动决策</b></p>
    <p>
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
    </p>
    <p><b>7、响应您的请求</b></p>
    <p>
      如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为陌陌回收存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本协议下方的方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
    </p>
    <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>（1）与个人信息控制者履行法律法规规定的义务相关的；</p>
    <p>（2）与国家安全、国防安全有关的；</p>
    <p>（3）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>（4）与犯罪侦查、起诉和审判等有关的；</p>
    <p>
      （5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；
    </p>
    <p>
      （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>
      （7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；
    </p>
    <p>（8）涉及商业秘密的。</p>
    <h4>六、儿童的个人信息保护</h4>
    <p>
      我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的用户账户。
    </p>
    <p>
      对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
    </p>
    <p>
      尽管当地法律和习俗对儿童的定义不同，但我们将不满
      14周岁的任何人均视为儿童。
    </p>
    <p>
      如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
    </p>
    <p>
      对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：
    </p>
    <p>
      （1）对于收集到的儿童的个人信息，我们除遵守本隐私政策关于用户个人信息保护的约定外，还会切实按照《儿童个人信息网络保护规定》的要求，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则。
    </p>
    <p>
      （2）我们严格遵循《网络安全法》、《中华人民共和国未成年人保护法》、《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露收集到的儿童个人信息，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。
    </p>
    <p>
      （3）当您作为监护人为被监护的儿童选择陌陌回收相关服务时，我们可能需要向您收集被监护儿童的个人信息，用于向您履行相关服务之必要。在具体的服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在使用晒单、评价等功能时，可能会主动向我们提供儿童的个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品或服务，您应当正确引导并予以监护。
    </p>
    <p>
      （4）儿童或者监护人有权访问、更正、删除儿童个人信息。如您对儿童个人信息相关事宜有任何意见、建议和诉求，请联系我们。我们会随时为您提供服务。
    </p>
    <h4>七、您的信息如何在全球范围转移</h4>
    <p>
      我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
    </p>
    <p>1、适用的法律有明确规定；</p>
    <p>2、获得您的明确授权；</p>
    <p>
      针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。
    </p>
    <p>
      如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
    </p>
    <p>涉及数据传输出境业务场景的具体说明：</p>
    <h4>八、修订和更新</h4>
    <p>
      1、为给您提供更好的服务以及随着陌陌回收业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在陌陌回收网站、陌陌回收移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问陌陌回收以便及时了解最新的隐私政策。
    </p>
    <p>
      2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
    </p>
    <p>本政策所指的重大变更包括：</p>
    <p>
      （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </p>
    <p>
      （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
    </p>
    <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>
      （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
    </p>
    <p>（6）个人信息安全影响评估报告表明存在高风险时。</p>
    <p>3、我们还会将本策略的旧版本存档，供您查阅。</p>
    <h4>九、如何联系我们</h4>
    <p>
      1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请拨打0755-2103-6187客服热线等多种方式与我们联系。
    </p>
    <p>2、<b>产品运营者基本情况</b></p>

    <table
      border="1"
      style="
        line-height: 24px;
        border-collapse: collapse;
        text-align: center;
        font-size: 16px;
      "
    >
      <tr>
        <th style="width: 20%">产品名称</th>
        <th style="width: 20%">公司名称</th>
        <th style="width: 20%">注册地址</th>
        <th style="width: 20%">常用办公地址</th>
        <th style="width: 20%">个人信息保护相关负责人联系方式</th>
      </tr>
      <tr>
        <td>陌陌回收APP</td>
        <td>深圳市致鑫钰科技有限公司</td>
        <td>深圳市龙岗区布吉街道京南路超力通大厦4楼409室</td>
        <td>深圳市龙华新区华荣路163号荣泰大厦1112</td>
        <td>0755-2103-6187</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.privacy{
  font-size: 16px;
  line-height: 24px;
}
</style>